import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProjectAndTypesService {
  private http = inject(HttpClient);

  public projects: Map<number, string> = new Map();
  public types: Map<number, string> = new Map();
  public services: Map<number, string> = new Map();

  public readonly isDataLoaded = signal(false);

  constructor() { }

  toMap = (obj?: Record<string, unknown>): Map<number, string> => {
    const m = new Map<number, string>();

    if (!obj) return m;

    for (const [k, v] of Object.entries(obj)) {
      // Convert key and value safely
      const key = Number(k);
      const value = v != null ? String(v) : ""; // handle null/undefined values gracefully
      m.set(key, value);
    }

    return m;
  };


  //Upload projects, services and types from the datastore
  uploadFromDataStore(): Observable<Object> {
    return this.http.get(environment.url + 'getprojectsandtypes').pipe(
      tap((data: any) => {
        this.projects = this.toMap(data.projects);
        this.types = this.toMap(data.types);
        this.services = this.toMap(data.services);
        this.isDataLoaded.set(true);
      })
    );
  }

  private reverseLookup(map: Map<number, string>, value: string): number | null {
    if (map.size === 0) return null;

    for (let [key, val] of map.entries()) {
      if (val === value) {
        return key;
      }
    }
    return null;
  }

  getProjectId(project: string): number | null {
    return this.reverseLookup(this.projects, project);
  }

  getTypeId(type: string): number | null {
    return this.reverseLookup(this.types, type);
  }

  getServiceId(service: string): number | null {
    return this.reverseLookup(this.services, service);
  }
}
